<nz-card *ngIf="isProgressVisible"
         class="progress-card"
         data-tour="setup-progress"
         [class.just-completed]="justCompleted">
  <div class="progress-container">
    <div *ngIf="justCompleted" class="completion-banner">
      <div>
        <strong>{{ 'PROGRESS.SUCCESS_TITLE' | translate }}</strong>
        <p>{{ 'PROGRESS.SUCCESS_SUBTITLE' | translate }}</p>
      </div>
    </div>

    <section class="onboarding-hero">
      <div class="onboarding-hero-copy">
        <span class="setup-badge">{{ 'PROGRESS.ONBOARDING_BADGE' | translate }}</span>

        <h2>{{ 'PROGRESS.ONBOARDING_TITLE' | translate }}</h2>

        <p>{{ 'PROGRESS.ONBOARDING_SUBTITLE' | translate }}</p>
      </div>

      <div class="progress-meter">
        <span class="progress-value">{{ progress }}%</span>
        <span class="progress-label">{{ 'PROGRESS.COMPLETE_LABEL' | translate }}</span>
      </div>
    </section>

<!--    <section class="progress-strip">-->
<!--      <div class="progress-strip-header">-->
<!--        <span>{{ 'PROGRESS.SETUP_PROGRESS' | translate }}</span>-->
<!--        <strong>-->
<!--          {{ 'PROGRESS.STEPS_COMPLETED' | translate: {-->
<!--          completed: milestones.length - incompleteMilestones.length,-->
<!--          total: milestones.length-->
<!--        } }}-->
<!--        </strong>-->
<!--      </div>-->

<!--      <nz-progress-->
<!--        [nzPercent]="progress"-->
<!--        [nzStrokeWidth]="10"-->
<!--        [nzShowInfo]="false"-->
<!--      ></nz-progress>-->
<!--    </section>-->

    <div
      *ngIf="progress < 100"
      class="onboarding-video-teaser"
      role="button"
      tabindex="0"
      (click)="openOnboardingVideoModal()"
      (keydown.enter)="openOnboardingVideoModal()"
    >
      <div class="teaser-left">
        <div class="thumb">
          <img
            src="assets/hero_video_preview.jpg"
            alt="Onboarding Video Preview"
          />
          <div class="play-overlay" aria-hidden="true">
            <svg width="52" height="52" viewBox="0 0 100 100" fill="none">
              <circle cx="50" cy="50" r="48" fill="rgba(0,0,0,0.55)"></circle>
              <polygon points="42,32 72,50 42,68" fill="white"></polygon>
            </svg>
          </div>
        </div>
      </div>

      <div class="teaser-right">
        <div class="teaser-text">
          <span class="video-badge">{{ 'PROGRESS.VIDEO.WATCH_TIME' | translate }}</span>

          <div class="teaser-title">
            {{ 'PROGRESS.VIDEO.TITLE' | translate }}
          </div>
          <div class="teaser-subtitle">
            {{ 'PROGRESS.VIDEO.SUBTITLE' | translate }}
          </div>
        </div>

        <button nz-button nzType="primary" nzSize="small" type="button">
          {{ 'PROGRESS.VIDEO.CTA' | translate }}
        </button>
      </div>
    </div>

    <section
      *ngIf="incompleteMilestones.length > 0 || justCompleted"
      class="next-actions"
      [class.completing-exit]="isCompletingExit"
    >
      <div class="section-heading">
        <h3>{{ 'PROGRESS.CONTINUE_SETUP_TITLE' | translate }}</h3>
        <p>{{ 'PROGRESS.CONTINUE_SETUP_SUBTITLE' | translate }}</p>
      </div>

      <div class="phase-progress">
        {{ 'PROGRESS.PHASE_PROGRESS' | translate:{completed: phaseOneCompletedCount} }}
      </div>

      <!-- Phase 1: Two parallel tasks -->
      <div class="phase-group">
        <div class="phase-label">{{ 'PROGRESS.PHASE_ONE_LABEL' | translate }}</div>

        <div class="phase-cards">

          <!-- Company information card -->
          <ng-container *ngIf="companyInfoMilestone as companyMilestone">
          <article
            class="setup-task-card"
            data-tour="setup-company-profile"
            [class.completed]="isCompanyInfoComplete"
          >
            <div class="task-header">
              <span *ngIf="isCompanyInfoComplete" class="task-status status-done">
                <span nz-icon nzType="check-circle" nzTheme="twotone" [nzTwotoneColor]="'#52c41a'"></span>
                {{ 'PROGRESS.TASK_COMPLETED' | translate }}
              </span>
              <span *ngIf="!isCompanyInfoComplete" class="task-status status-todo">
                <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
                {{ 'PROGRESS.REQUIRED_LABEL' | translate }}
              </span>
            </div>

            <h4>{{ getMilestoneLabel(companyMilestone.key, 'TITLE') | translate }}</h4>

            <p class="task-description">
              {{ getMilestoneLabel(companyMilestone.key, 'DESCRIPTION') | translate }}
            </p>

            <ng-container *ngIf="!isCompanyInfoComplete">
              <ul *ngIf="companyMilestone.missingSections?.length" class="task-missing-list">
                <li *ngFor="let detail of companyMilestone.missingSections">
                  <ng-container *ngIf="isFieldMissing(detail)">
                    {{ getFieldLabelKey(companyMilestone.key, detail.key) | translate }}
                  </ng-container>
                </li>
              </ul>

              <button
                type="button"
                nz-button
                nzType="primary"
                class="task-action"
                (click)="handleMilestoneActionClick($event, companyMilestone)"
              >
                {{ getMilestoneLabel(companyMilestone.key, 'ACTION') | translate }}
              </button>
            </ng-container>
          </article>
          </ng-container>

          <!-- Landing page configuration card -->
          <ng-container *ngIf="landingPageMilestone as landingMilestone">
          <article
            class="setup-task-card"
            data-tour="setup-digital-configuration"
            [class.completed]="isLandingPageComplete"
          >
            <div class="task-header">
              <span *ngIf="isLandingPageComplete" class="task-status status-done">
                <span nz-icon nzType="check-circle" nzTheme="twotone" [nzTwotoneColor]="'#52c41a'"></span>
                {{ 'PROGRESS.TASK_COMPLETED' | translate }}
              </span>
              <span *ngIf="!isLandingPageComplete" class="task-status status-todo">
                <span nz-icon nzType="exclamation-circle" nzTheme="outline"></span>
                {{ 'PROGRESS.REQUIRED_LABEL' | translate }}
              </span>
            </div>

            <h4>{{ getMilestoneLabel(landingMilestone.key, 'TITLE') | translate }}</h4>

            <p class="task-description">
              {{ getMilestoneLabel(landingMilestone.key, 'DESCRIPTION') | translate }}
            </p>

            <ng-container *ngIf="!isLandingPageComplete">
              <ul *ngIf="landingMilestone.missingSections?.length" class="task-missing-list">
                <li *ngFor="let detail of landingMilestone.missingSections">
                  <ng-container *ngIf="isFieldMissing(detail)">
                    {{ getFieldLabelKey(landingMilestone.key, detail.key) | translate }}
                  </ng-container>
                </li>
              </ul>

              <button
                type="button"
                nz-button
                nzType="primary"
                class="task-action"
                (click)="handleMilestoneActionClick($event, landingMilestone)"
              >
                {{ getMilestoneLabel(landingMilestone.key, 'ACTION') | translate }}
              </button>
            </ng-container>
          </article>
          </ng-container>
        </div>
      </div>

      <!-- Phase connector -->
      <div class="phase-connector" [class.active]="allPhaseOneComplete">
        <svg width="24" height="32" viewBox="0 0 24 32" aria-hidden="true">
          <line x1="12" y1="0" x2="12" y2="20" stroke-width="2" stroke-linecap="round" />
          <polyline points="4,16 12,24 20,16" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <!-- Phase 2: Property (locked until Phase 1 complete) -->
      <ng-container *ngIf="propertyMilestone as propMilestone">
      <div class="phase-group">
        <div class="phase-label">
          <ng-container *ngIf="!allPhaseOneComplete">
            {{ 'PROGRESS.PHASE_TWO_LABEL' | translate }}
          </ng-container>
          <ng-container *ngIf="allPhaseOneComplete">
            {{ 'PROGRESS.PHASE_TWO_READY_LABEL' | translate }}
          </ng-container>
        </div>

        <div class="phase-cards">
          <article
            class="setup-task-card"
            data-tour="setup-first-property"
            [class.locked]="!isPropertyStepUnlocked"
            [class.completed]="propMilestone.completed"
          >
            <div class="task-header">
              <span *ngIf="propMilestone.completed" class="task-status status-done">
                <span nz-icon nzType="check-circle" nzTheme="twotone" [nzTwotoneColor]="'#52c41a'"></span>
                {{ 'PROGRESS.TASK_COMPLETED' | translate }}
              </span>
              <span *ngIf="!propMilestone.completed && !isPropertyStepUnlocked" class="task-status status-locked">
                <span nz-icon nzType="lock" nzTheme="outline"></span>
                {{ 'PROGRESS.TASK_LOCKED' | translate }}
              </span>
              <span *ngIf="!propMilestone.completed && isPropertyStepUnlocked" class="task-status status-available">
                <span nz-icon nzType="unlock" nzTheme="outline"></span>
                {{ 'PROGRESS.TASK_AVAILABLE' | translate }}
              </span>
            </div>

            <h4>{{ getMilestoneLabel(propMilestone.key, 'TITLE') | translate }}</h4>

            <p class="task-description">
              <ng-container *ngIf="!isPropertyStepUnlocked">
                {{ 'PROGRESS.PROPERTY_LOCKED_DESCRIPTION' | translate }}
              </ng-container>
              <ng-container *ngIf="isPropertyStepUnlocked">
                {{ 'PROGRESS.PROPERTY_UNLOCKED_DESCRIPTION' | translate }}
              </ng-container>
            </p>

            <ng-container *ngIf="isPropertyStepUnlocked && !propMilestone.completed">
              <ul *ngIf="propMilestone.missingSections?.length" class="task-missing-list">
                <li *ngFor="let detail of propMilestone.missingSections">
                  <ng-container *ngIf="isFieldMissing(detail)">
                    {{ getFieldLabelKey(propMilestone.key, detail.key) | translate }}
                  </ng-container>
                  <ng-container *ngIf="isPropertyMissing(detail)">
                    {{ getPropertyMissingText(detail) }}
                  </ng-container>
                </li>
              </ul>

              <button
                type="button"
                nz-button
                nzType="primary"
                class="task-action"
                (click)="handleMilestoneActionClick($event, propMilestone)"
              >
                {{ getMilestoneLabel(propMilestone.key, 'ACTION') | translate }}
              </button>
            </ng-container>

            <ng-container *ngIf="!isPropertyStepUnlocked">
              <button
                type="button"
                nz-button
                nzType="default"
                class="task-action"
                disabled
                aria-disabled="true"
              >
                {{ getMilestoneLabel(propMilestone.key, 'ACTION') | translate }}
              </button>
            </ng-container>
          </article>
        </div>
      </div>
      </ng-container>
    </section>
  </div>
</nz-card>
<!-- Modal template -->
<ng-template #onboardingVideoModal>
  <div class="video-16x9">
    <iframe
      [src]="onboardingVideoUrl"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</ng-template>
<!-- Missing steps modal -->
<ng-template #missingStepsModal>
  <p>{{ 'PROGRESS.BLOCK_PROPERTIES.DESCRIPTION' | translate }}</p>
  <ul style="margin: 0; padding-left: 18px;">
    <li *ngFor="let m of missingBeforeTarget">
      {{ getMilestoneLabel(m.key, 'TITLE') | translate }}
    </li>
  </ul>
</ng-template>
